<template>
  <div class="container button-padding-5">
    <wrap-container class="grid-container grid-container--8-4">
      <text-input
        class="col1"
        :value="value.calle"
        :name="setName('calle')"
        @input="onCalle"
        label="Calle"
        :required="true"
        :scrollOnFocus="step4 ? false : true"
        analyticsName="calle"
        :analyticsTypology="config.analyticsTypology"
        :analyticsSubmodule="setAnalyticsSubmodule()"
        :quantumObfuscate="quantumObfuscate"
      />
      <number-input
        class="col2"
        :value="value.numero"
        :name="setName('numero')"
        @input="onNumero"
        label="Número"
        :required="true"
        maxlength="5"
        :scrollOnFocus="step4 ? false : true"
        analyticsName="número"
        :analyticsSubmodule="setAnalyticsSubmodule()"
        :quantumObfuscate="quantumObfuscate"
      />
    </wrap-container>

    <wrap-container class="grid-container grid-container--4-4-4">
      <text-input
        class="col1"
        :value="value.piso"
        :name="setName('piso')"
        @input="onPiso"
        label="Piso"
        :scrollOnFocus="step4 ? false : true"
        :quantumObfuscate="quantumObfuscate"
        maxlength="3"
      />
      <text-input
        class="col2"
        :value="value.dpto"
        :name="setName('dpto')"
        @input="onDpto"
        label="Dpto."
        :scrollOnFocus="step4 ? false : true"
        :quantumObfuscate="quantumObfuscate"
        maxlength="5"
      />
      <number-input
        class="col3"
        :value="value.codigoPostal"
        :name="setName('codigoPostal')"
        @input="onCP"
        label="CP"
        :required="true"
        maxlength="5"
        :scrollOnFocus="step4 ? false : true"
        analyticsName="cp"
        :analyticsSubmodule="setAnalyticsSubmodule()"
        :quantumObfuscate="quantumObfuscate"
      />
    </wrap-container>

    <wrap-container>
      <province-list
        class="col1 mb"
        :value="value.codProvincia"
        :name="setName('provincia')"
        @input="onProvincia"
        :scrollOnFocus="step4 ? false : true"
        :quantumObfuscate="quantumObfuscate"
      />
    </wrap-container>

    <wrap-container>
      <city-list
        class="col2 mb"
        :value="value.localidad || value.localid"
        :name="setName('localidad')"
        :codProv="value.codProvincia"
        @input="onLocalidad"
        :scrollOnFocus="step4 ? false : true"
        :quantumObfuscate="quantumObfuscate"
      />
    </wrap-container>
    <wrap-container v-if="value.valido === false">
      <floating-error
        :description="errorNormalizacion"
        :showErrorIcon="true"
        errorCode="error-normalizacion-merlin"
      ></floating-error>
    </wrap-container>
    <wrap-container v-if="this.value.valido === false && searchEncontesa">
      <search-encontesa
        :domicilio="value"
        :otroDomicilio="otroDomicilio"
        :step4="step4"
        @selectValid="$emit('valid')"
      />
    </wrap-container>
    <wrap-container v-if="showSelectOptions">
      <address-select-options
        :options="value.lineas"
        :otroDomicilio="otroDomicilio"
        :step4="step4"
        @selectValid="$emit('valid')"
      />
    </wrap-container>
  </div>
</template>

<script>
import get from "lodash/get";
import addressData from "@/mixins/address-data";
import WrapContainer from "@/components/core/Container";
import TextInput from "@/components/core/TextInput";
import NumberInput from "@/components/core/NumberInput";
import ProvinceList from "@/components/core/composite/combos/ProvinceList";
import CityList from "@/components/core/composite/combos/CityList";
import FloatingError from "@/components/core/custom/FloatingError";
import SearchEncontesa from "@/components/core/SearchEncontesa";
import AddressSelectOptions from "@/components/core/AddressSelectOptions.vue";

export default {
  name: "AddressDataOld",
  mixins: [addressData],
  components: {
    WrapContainer,
    TextInput,
    NumberInput,
    ProvinceList,
    CityList,
    FloatingError,
    SearchEncontesa,
    AddressSelectOptions
  },
  props: {
    value: Object,
    searchEncontesa: Boolean,
    otroDomicilio: Boolean,
    step4: Boolean,
    quantumObfuscate: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    errorNormalizacion() {
      if (get(this.value, "lineas", []).length && !this.searchEncontesa) {
        // En este caso tenemos opciones para elegir con duda merlin
        return "";
      }
      let error =
        "Lo sentimos, no pudimos verificar la dirección. Revisá los datos de arriba para ver si son correctos";
      return this.searchEncontesa
        ? error + " o elegí las opciones de verificación."
        : error;
    },
    showSelectOptions() {
      return get(this.value, "lineas", []).length > 0;
    }
  },
  methods: {
    setName(name) {
      return this.otroDomicilio ? `otro.${name}` : `domicilio.${name}`;
    },
    setAnalyticsSubmodule() {
      if (this.step4) {
        return this.otroDomicilio ? "otro domicilio" : "modificar domicilio";
      }
      return null;
    }
  }
};
</script>

<style scoped>
.button-padding-5 {
  padding-bottom: 5px !important;
}
.mb {
  margin-bottom: 25px;
}
</style>
